import { useSelector } from 'react-redux';
import { selectIsAgent } from '../../selectors/user';
import { selectIsFromOfferCard } from '../../selectors/page';

export function useIsSearcherFromOfferCard() {
  const isAgent = useSelector(selectIsAgent);
  const isFromOfferdCard = useSelector(selectIsFromOfferCard);

  return !isAgent && isFromOfferdCard;
}
